const obj = {
  id: '',
  eventId: '',
  scheduleId: '',
  guestId: '',
  serialNumber: 0,
  guestName: '',
  guestEmail: '',
}

export default function ScheduleCheckinUniqueNumberModel(params = obj) {
  return { ...obj, ...params, };
};
